import { capitalize, groupBy, uniqBy } from 'lodash-es';

import rawData from '../-data/targets.csv';

const KPI_COLUMN_MAP = {
  patientsTreated: 'KPI 1: Patients receiving treatment',
  increasingMedicalAccess: 'KPI 2: Increasing access of medical products and services for patients',
  patientsSavingPremium: 'KPI 3: Patient savings',
  netPromoterScore: 'KPI 4: Patient satisfaction',
  employeesTrained: 'KPI 5: Employees provided with healthcare training',
  decentJobs: 'KPI 7: Decent jobs',
  investeeRevenueGrowth: 'KPI 8: Investee revenue growth',
};

interface SDGTargetRow {
  KPI: string;
  Type: 'Country' | 'Region' | 'World';
  Geography: string;
  'ISO-3': string;
  Target: number;
}

export function getSDGTargetData() {
  return rawData as SDGTargetRow[];
}

export function getRegionsByType(type: 'country' | 'region' | 'world') {
  return uniqBy(getSDGTargetData(), 'Geography')
    .filter((x) => x.Type === capitalize(type))
    .map((x) => x.Geography)
    .sort();
}

export function getRegionType(region: string): SDGTargetRow['Type'] {
  const match = getSDGTargetData().find((x) => x.Geography === region);
  if (!match) throw new Error(`Unknown Region: ${region}`);
  return match.Type;
}

export function getTarget(kpi: keyof typeof KPI_COLUMN_MAP, region: string): number | null {
  const targets = groupBy(getSDGTargetData(), 'KPI')[KPI_COLUMN_MAP[kpi]] ?? [];
  return targets.find((t) => t.Geography === region)?.Target ?? null;
}
